import {get as _get} from 'lodash';

import { BASE_FORM_MESSAGES, CIDR, FORM_ERROR, SAVED } from '@constants/messages';
import {CLIENT_WHITELISTED_IP} from '@constants/resources';

import validate from './validatorWhitelistedIp';
import {createFieldsByType} from '../utils/whitelistingHelper';
import {
    CreateClientWhitelistedIp,
    DisableClientWhitelistedIp,
    UpdateClientWhitelistedIp,
} from '../../../graphql/clientWhitelistedIp/mutation.graphql';
import {
    GetClientWhitelistedIpDropdownData,
    GetWhitelistedIpData,
} from '../../../graphql/clientWhitelistedIp/query.graphql';

const getCidrFromMutationResponse = (response) => (
    _get(response, 'data.createClientWhitelistedIp.cidr')
    ?? _get(response, 'data.updateClientWhitelistedIp.cidr')
    ?? _get(response, 'data.createClientAvapiWhitelistedIp.cidr')
    ?? _get(response, 'data.updateClientAvapiWhitelistedIp.cidr')
);

const getCidrSuccessHeader = (response) => {
    const cidr = getCidrFromMutationResponse(response);

    return cidr ? SAVED(CIDR, cidr) : undefined;
};

export default function WhitelistedIpModel() {
    return {
        entityDataMapKey: 'clientWhitelistedIp',
        entityLabel: 'whitelisted IPs',
        formName: 'whitelistedIps',
        label: 'Whitelisted IP',
        resources: CLIENT_WHITELISTED_IP,
        showChangelog: true,
        title: 'Add new CIDR',
        validate: validate,
        dataMap: {
            clientWhitelistedIp: {
                id: '',
                ip_version: '',
                cidr: '',
                description: '',
                products: [],
            },
        },
        messages: {
            boxName: {
                delete: 'whitelistedIpMessage',
                error: 'formInnerErrorMessage',
                success: 'whitelistedIpMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                FORM_ERROR: () => FORM_ERROR(CIDR),
            },
            create: {
                getHeader: getCidrSuccessHeader,
            },
            update: {
                getHeader: getCidrSuccessHeader,
            },
        },
        fields: {
            ...createFieldsByType('whitelisted'),
        },
        mutation: {
            createEntity: CreateClientWhitelistedIp,
            deleteEntity: DisableClientWhitelistedIp,
            updateEntity: UpdateClientWhitelistedIp,
        },
        query: {
            getEntity: GetWhitelistedIpData,
            getOptions: GetClientWhitelistedIpDropdownData,
        },
    };
}
